import React, { useState } from 'react'
import { Button, CircularProgress } from '@material-ui/core'

import { ReactComponent as UploadButton } from 'assets/icons/upload-button.svg'
import { useApiCall } from 'hooks/useApi'
import { snackbar } from 'components'
import { ERRORS } from 'consts'

import { uploadPhysicalTickets } from './api'

interface ApiError {
  response?: {
    data?: {
      error?: string
    }
  }
}

export const UploadTickets = () => {
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [uploadCall, uploadLoading] = useApiCall(uploadPhysicalTickets)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    if (selectedFile) {
      if (selectedFile.type !== 'text/csv') {
        setError('Por favor, selecciona un archivo CSV')
        setFile(null)
        return
      }
      setFile(selectedFile)
      setError(null)
    }
  }

  const handleUpload = async () => {
    if (!file) return

    try {
      const reader = new FileReader()
      reader.onload = async e => {
        try {
          const content = e.target?.result as string
          await uploadCall(content)
          setFile(null)
          setError(null)
          // Reset file input
          const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement
          if (fileInput) fileInput.value = ''
          // Show success message
          snackbar.show('Archivo procesado correctamente')
          // Refresh the page to show updated data
          window.location.reload()
        } catch (err) {
          const errorMessage =
            (err as ApiError).response?.data?.error || ERRORS.GENERIC_ERROR_MESSAGE
          setError(errorMessage)
          snackbar.show(errorMessage)
          console.error('Error uploading file:', err)
        }
      }
      reader.readAsText(file)
    } catch (err) {
      setError('Error al procesar el archivo')
      snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      console.error('Error uploading file:', err)
    }
  }

  return (
    <div className="flex flex-col items-center ml-2">
      <input
        accept=".csv"
        style={{ display: 'none' }}
        id="csv-file-upload"
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor="csv-file-upload">
        <Button
          variant="text"
          component="span"
          disabled={uploadLoading}
          disableRipple
          style={{
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          {uploadLoading ? <CircularProgress size={24} /> : <UploadButton />}
        </Button>
      </label>
      {file && (
        <div className="flex flex-col items-center gap-2">
          <span className="text-sm text-gray-600">{file.name}</span>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={uploadLoading}
          >
            {uploadLoading ? <CircularProgress size={24} /> : 'Procesar Archivo'}
          </Button>
        </div>
      )}
      {error && <div className="text-red-500 text-sm text-center max-w-md">{error}</div>}
    </div>
  )
}
